module.exports = __webpack_public_path__ + "img/img-google-download@3x.6acaa56a.jpg";